export const productsTransformer = (serverData, locale) => {
  const yesValue = locale === "et" ? "Jah" : "Yes";
  const noValue = locale === "et" ? "Ei" : "No";

  return {
    id: serverData.id,
    name: serverData.name,
    externalId: serverData.id,
    designImageUrl: serverData.designImageSlider?.[0]?.designImage?.url || null,
    categoryName: serverData.family?.value?.name || null,
    subGroupName: serverData.family?.value?.subcategory?.value || null,
    tags: serverData.tags || "",
    uniqueProperties: serverData.uniqueProperties || "",
    featuresArray: serverData.featuresArray.map((feature) => {
      let value = feature.featureValue;

      // Check for boolean and convert to yes/no
      if (value === "true") {
        value = yesValue;
      } else if (value === "false") {
        value = noValue;
      }

      return {
        name: feature.feature?.name || "",
        value: value || "",
      };
    }),
  };
};
